import * as React from "react";
import { MessageDialog } from "../../../../../components/message-dialog";

type Props = {
    open: boolean
    onClose: () => void
    onConfirm: () => void
}

export const DoseWarningDialog: React.FC<Props> = ({ open, onClose, onConfirm }) => {
    return (
        <MessageDialog
            open={open}
            onClose={onClose}
            onConfirm={onConfirm}
            title="Deseja continuar?"
            message="Você possui itens na lista com valores fora do intervalo recomendado."
            confirmButtonText="Sim"
            cancelButtonText="Não"
        />
    )
}
